import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["type", "children", "settings", "modifier", "backgroundImage", "tagType", "dataNoSnippet", "sticky", "VariantComponent"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../Wrapper';
import { getClassModifiers } from '../../utils';
import { useGetImages } from '../../hooks';
import { getStylesToUpdate, checkIfRowHasColumns } from './helpers';
import { renderChildren, hasChildren } from '../../helpers';
import { COLUMN } from '../../constants';
const Layout = React.forwardRef((_ref, ref) => {
  let {
      type,
      children,
      settings,
      modifier,
      backgroundImage,
      tagType,
      dataNoSnippet,
      sticky,
      VariantComponent
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  const {
    data: {
      getFile: {
        url = null
      } = {}
    }
  } = useGetImages(backgroundImage);
  const style = getStylesToUpdate({
    backgroundImage: url
  });
  const {
    title
  } = settings;
  const classModifiers = getClassModifiers(type, _objectSpread({
    modifier,
    sticky
  }, otherProps));
  const additionalRowModifier = checkIfRowHasColumns(type, children) ? ' display-row' : '';
  if (type === COLUMN && !hasChildren(children)) return null;
  const otherWrapperProps = {};
  if (dataNoSnippet) otherWrapperProps['data-nosnippet'] = true;
  const WrapperComponent = VariantComponent || Wrapper;
  return /*#__PURE__*/React.createElement(WrapperComponent, _extends({
    ref: ref,
    tagType: tagType,
    className: type,
    modifiers: `${classModifiers}${additionalRowModifier}`,
    style: style
  }, otherWrapperProps), title && /*#__PURE__*/React.createElement("h2", {
    className: "heading heading--section"
  }, title), renderChildren(children, otherProps));
});
Layout.propTypes = {
  type: PropTypes.string.isRequired,
  sticky: PropTypes.bool,
  settings: PropTypes.shape({
    title: PropTypes.string
  }),
  modifier: PropTypes.string,
  backgroundImage: PropTypes.string,
  tagType: PropTypes.string,
  dataNoSnippet: PropTypes.bool,
  VariantComponent: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};
Layout.defaultProps = {
  settings: {
    title: ''
  },
  backgroundImage: '',
  modifier: '',
  tagType: '',
  dataNoSnippet: false,
  sticky: false,
  VariantComponent: null
};
export default Layout;
//# sourceMappingURL=Layout.js.map